interface ProviderConstructorProps {
	id: string;
	name: string;
	description: string;
	websiteHomeUrl: string;
	websiteSupportUrl: string;
	iconUrl: string;
	color: string;
}

class Provider {
	constructor(public _: ProviderConstructorProps) {}

	toJson = () => {
		return {
			id: this._.id,
			name: this._.name,
			description: this._.description,
			website_home_url: this._.websiteHomeUrl,
			website_support_url: this._.websiteSupportUrl,
			icon_url: this._.iconUrl,
			color: this._.color,
		};
	};

	static fromJson = (json: any) => {
		return new Provider({
			id: json.id,
			name: json.name,
			description: json.description,
			websiteHomeUrl: json.website_home_url,
			websiteSupportUrl: json.website_support_url,
			iconUrl: json.icon_url,
			color: json.color,
		});
	};
}

interface ProvidersCatalogProps {
	providers: Provider[];
}

class ProvidersCatalog {
	constructor(private _: ProvidersCatalogProps) {}

	get providers() {
		return this._.providers;
	}

	providerFromId = (id: string) => {
		return this._.providers.find((provider) => provider._.id === id);
	};
}

export { Provider, ProvidersCatalog };
